import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M33.97 2.353H6.03a3.68 3.68 0 0 0-3.677 3.676v27.942a3.68 3.68 0 0 0 3.676 3.676h27.942a3.68 3.68 0 0 0 3.676-3.676V6.029a3.68 3.68 0 0 0-3.676-3.676m.736 3.676v12.5H21.47V5.294h12.5c.406 0 .735.33.735.735M6.029 5.294h12.5V18.53H5.295V6.03c0-.404.33-.735.735-.735m-.735 28.677v-12.5H18.53v13.235H6.03a.736.736 0 0 1-.736-.735m28.677.735h-12.5V21.47h13.235v12.5c0 .405-.33.736-.735.736"
    }, null, -1)
  ]))]))
}
export default { render: render }